import Immutable from 'immutable';

const UserRole = Immutable.Record({
  key: '',
  id: '',
  roleId: '',
  roleName: '',
  fullName: '',
  associatName: '',     // 'student' || 'classRecord'
  associatObj: {
    id: -1
  }
});

export default UserRole;


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/stores/UserRole.js